import { useCallback, useState } from "react";
import classnames from "classnames";
import { useController } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";
import styles from "@/styles/Form.module.scss";

export default function MultipleCheckboxField({
  options,
  control,
  name,
  error,
  title,
  help,
  required,
  row,
  defaultValue = [],
}) {
  const { field } = useController({ control, name, defaultValue });
  const [value, setValue] = useState(defaultValue);

  const handleChange = useCallback(
    (e) => {
      const newValue = (() => {
        if (e.target.checked) {
          return [...value, e.target.value];
        } else {
          return value.filter((v) => v !== e.target.value);
        }
      })();
      field.onChange(newValue);
      setValue(newValue);
    },
    [value]
  );

  return (
    <fieldset className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
          })}
        >
          {title}
        </legend>
      )}
      {help && <span className={styles.help}>{help}</span>}
      <div
        className={classnames(styles.multipleCheckbox, { [styles.row]: row })}
      >
        {options.map((option, index) => (
          <div
            className={classnames(styles.checkbox)}
            key={`checkbox-${name}-${index}`}
          >
            <input
              id={`checkbox-${name}-${index}`}
              type="checkbox"
              value={option.value}
              onChange={handleChange}
              onBlur={field.onBlur}
            />
            <label
              htmlFor={`checkbox-${name}-${index}`}
              className={styles.label}
              tabIndex="0"
              onBlur={field.onBlur}
            >
              <span>{option.label}</span>
            </label>
          </div>
        ))}
      </div>
      {error && <ErrorMessage msg={error} />}
    </fieldset>
  );
}